import React from 'react';
import { PortraitsWithTextType } from '@appTypes/portraitsWithTextType';
import { PortraitsWithTextBlock } from '@components/SectionBlocks/blocks/PortraitsWithTextBlock';

export interface PortraitsWithTextProps {
  value: PortraitsWithTextType;
}

export const PortraitsWithText = ({ value }: PortraitsWithTextProps) => <PortraitsWithTextBlock block={value} />;
